import React, { useState } from "react";
import {
  Paper,
  Box,
  Typography,
  TextField,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import { sendMagicLinkToUser } from "../api";

const InviteUser = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);

  const sendInvite = async () => {
    setLoading(true);
    setError("");

    if (!/\S+@\S+\.\S+/.test(email)) {
      setError("Please enter a valid email address.");
      setLoading(false);
      return;
    }

    try {
      const data = await sendMagicLinkToUser(email);
      if (data.success) {
        setShowSuccess(true);
        setEmail("");
      } else {
        setError(data.message || "Failed to send invite.");
      }
    } catch (e) {
      setError("Network error. Please try again.");
    }
    setLoading(false);
  };

  return (
    <Paper
      elevation={0}
      sx={{
        maxWidth: 650,
        margin: "60px auto",
        borderRadius: 4,
        padding: 5,
        background: "#F6F2FC",
        boxShadow: "0 2px 12px #EFECF6",
      }}
    >
      <Typography
        variant="h5"
        sx={{
          mb: 2,
          fontWeight: 600,
          color: "#6D32A6",
          letterSpacing: 0.2,
        }}
      >
        Invite a User
      </Typography>
      <Typography
        variant="body1"
        sx={{ mb: 4, color: "#8369AA", fontSize: 19 }}
      >
        Enter an email address below to send an invitation to join.
      </Typography>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          alignItems: "flex-start",
          background: "#fff",
          borderRadius: 3,
          padding: 3,
        }}
      >
        <TextField
          label="User Email"
          variant="outlined"
          size="medium"
          fullWidth
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            setError("");
          }}
          disabled={loading}
          sx={{
            background: "#fff",
            borderRadius: 2,
            fontSize: 16,
            fontWeight: 400,
          }}
          error={!!error}
          helperText={error}
          FormHelperTextProps={{
            style: {
              marginTop: 4,
              marginBottom: 0,
              fontSize: 17,
              color: "#D32F2F",
              fontWeight: 600,
            },
          }}
        />
        <Button
          variant="contained"
          sx={{
            background: "#7209d4",
            fontWeight: 600,
            borderRadius: 3,
            px: 4,
            py: 2,
            textTransform: "none",
            fontSize: 20,
            boxShadow: "none",
            minWidth: 200,
            ":hover": { background: "#6D32A6" },
          }}
          disabled={loading}
          onClick={sendInvite}
        >
          <span style={{ display: "inline", lineHeight: 1.2 }}>
            {loading ? "Sending..." : "Send Invite"}
          </span>
        </Button>
      </Box>
      {/* Snackbar for success */}
      <Snackbar
        open={showSuccess}
        autoHideDuration={3500}
        onClose={() => setShowSuccess(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          severity="success"
          variant="filled"
          sx={{
            fontSize: 18,
            background: "#20B26C",
            color: "#fff",
            fontWeight: 600,
            borderRadius: 2,
          }}
          onClose={() => setShowSuccess(false)}
        >
          Invitation sent!
        </Alert>
      </Snackbar>
    </Paper>
  );
};

export default InviteUser;
